import React, { useState } from 'react'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import { componentKey as AuthenticationComponentKey } from '../../authentication/AuthenticationSlice'
import { useDispatch, useSelector } from 'react-redux'
import DateUtils from '../../../../libs/utility/DateUtils'
import Label from '../../../components/label/Label'
import { LABEL_WEIGHT } from '../../../components/label/constants'
import styles from './ActivityLogs.styles'
import TextInput from '../../../components/input/textinput/TextInput'
import CalendarInputWDateFormat from '../../../components/input/calendarinput/CalendarInputWDateFormat'
import Button from '../../../components/button/Button'
import { BUTTON_TYPE } from '../../../components/button/constants'
import { componentKey, setActivityLogs, setEndDate, setEventName, setRole, setRowsPerPage, setSelectedLog, setSkip, setStartDate, setUserName } from './ActivityLogsSlice'
import Loadable from '../../../components/loadable/Loadable'
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks'
import RichGrid from '../../../components/richgrid/RichGrid'
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants'
import { Theme } from '../../../components/constants'
import { useEffect } from 'react'
import { getActivityLogDetails, getActivityLogExportExcel, getActivityLogs } from './ActivityLogsSaga'
import Popup from '../../../components/popup/Popup'
import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown'
import { ACTIVITY_LOGS_LOADING_STATES, ACTIVITY_LOGS_LOADING_STATES_MESSAGE_MAP, COMMON_EXPORTING_STATES, COMMON_EXPORTING_STATES_MESSAGE_MAP } from '../../constants/constants'
import { useUserTypeInfo } from '../../../../libs/customhooks/useUserTypeInfo'
import { USER_TYPE } from '../../../../libs/customhooks/constants'

export default function ActivityLogs() {
    useGarbageCollector(componentKey)

    const {signedInUser} = useSelector((state) => state[AuthenticationComponentKey])
    const {userType} = useUserTypeInfo();
    const { userName, eventName, activityLogs, selectedLog, rowsPerPage, skip, role, startDate, endDate, loadingState, totalLogs, exportFile } = useSelector((state) => state[componentKey])
    const [showDetailsPopup, setShowDetailsPopup] = useState(false);
    const dispatch = useDispatch()

    let userOptions = [
        {label: "User", value: "User"},
        {label: "Support", value: "Support"}
    ]

    if(userType === USER_TYPE.MEMBER_USER) {
        userOptions.push({label: "Admin", value: "Admin"})
    } else {
        userOptions.push({label: "Member", value: "Member"})
    }

    const [selectedRole, setSelectedRole] = useState(userOptions[0])

    useEffect(()=> {
        dispatch(getActivityLogs({userName, eventName, skip, rowsPerPage, role, startDate, endDate}))
    }, [userName,eventName, ,startDate, endDate, role, rowsPerPage, skip])

    const base64ToBlob = (base64Data) => {
        const byteString = atob(base64Data);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab]);
      };

    useEffect(()=>{
        if(exportFile.hasOwnProperty('Name') && exportFile.hasOwnProperty('Base64')){
            const blob = base64ToBlob(exportFile.Base64);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = exportFile.Name;
            link.click();
        }
    }, [exportFile])

    const handleInputChange = (e) => {
        const name = e.target.name;
        switch (name) {
            case 'userName':
                dispatch(setUserName(e.target.value))
                break;
            case 'eventName':
                dispatch(setEventName(e.target.value))
                break;
        }
    }

    const handleStartDate = (e) => {
        dispatch(setStartDate(DateUtils.dateFormatter(e, "MM/DD/YYYY")))
    }

    const handleEndDate = (e) => {
        dispatch(setEndDate(DateUtils.dateFormatter(e, "MM/DD/YYYY")))
    }

    const handleViewDetails = (row) => {
        setShowDetailsPopup(true)
        dispatch(getActivityLogDetails({applicationUserLog: row.ApplicationUserLogId}))
    }
    const handleRoleChange = (name, selectedOption) => {
        setSelectedRole(selectedOption)
        dispatch(setRole(selectedOption.value))
    }
    const ACTIVITY_LOGS_COLUMNS = [
        {
            field: "userName",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>User Name</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{ row.userName }</span>
        },
        {
            field: "role",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Role</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{ row.Role }</span>
        },
        {
            field: "eventName",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Event Name</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.TableName}</span>
        },
        {
            field: "eventDate",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Event Date</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{DateUtils.dateFormatter(row.Created_Date, "MM/DD/YYYY, h:mm:ss a")}</span>
        },
        {
            field: "ipAddress",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>IP Address</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.IPAddress}</span>
        },
        {
            field: "action",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Actions</Label>,
            renderLogic: (row, idx) => <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => handleViewDetails(row)}>View Details</Button>
        },
    ]

    const handleExportExcel = () => {
        dispatch(getActivityLogExportExcel(role))
    }

  return (
    <div style={styles.mainContainer}>
        <div style={styles.headerRow}>
            <Heading type={HEADING.H1}>User Activity Logs</Heading>
            <Heading type={HEADING.H2}>Last Login Date: {DateUtils.dateFormatter(signedInUser?.LastLoggedIn, "MM/DD/YYYY, h:mm:ss a")}</Heading>
        </div>
        <div style={styles.actionsRow}>
            <div>
                <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Search by User: </Label>
                <TextInput 
                    type={'text'}
                    placeHolder={"Search Here"} 
                    name={'userName'} 
                    value={userName} 
                    onChangeCb={(e) => handleInputChange(e)} 
                />
            </div>

            <div>
                <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Search by Event Name: </Label>
                <TextInput 
                    type={'text'}
                    placeHolder={"Search Here"} 
                    name={'eventName'} 
                    value={eventName} 
                    onChangeCb={(e) => handleInputChange(e)} 
                />
            </div>
            <div>
                <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Role Filter: </Label>
                
                    <SelectDropdown
                            name="Role"
                            value={{ label: selectedRole.label, value: selectedRole.value }}
                            prefixProps={{ text: "" }}
                            onSelectCb={(name, selectedOption) => handleRoleChange(name, selectedOption)}
                            options={userOptions}
                    />
            </div>
            <div>
                <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Date Filter: </Label>
                <div style={styles.dateFilter}>
                    <CalendarInputWDateFormat 
                        label={"Select start date"}
                        name='startDate'
                        value={startDate}
                        onChangeCb={(e) => handleStartDate(e)}
                    />
                    <CalendarInputWDateFormat 
                        label={"Select end date"}
                        name='endDate'
                        value={endDate}
                        onChangeCb={(e) => handleEndDate(e)}
                    />
                </div>
            </div>
        <Loadable currentState={loadingState.state}  loadingStates={COMMON_EXPORTING_STATES.EXPORT_LOADING} messageMap={COMMON_EXPORTING_STATES_MESSAGE_MAP} isNewLoadable={true}>
            <Button type={BUTTON_TYPE.PRIMARY} onClickCb={handleExportExcel}>Export Excel</Button>
        </Loadable>
        </div>
        <Loadable currentState={loadingState.state}  loadingStates={ACTIVITY_LOGS_LOADING_STATES.GRID_LOADING} messageMap={ACTIVITY_LOGS_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
            <RichGrid
                data={activityLogs}
                columns={ACTIVITY_LOGS_COLUMNS}
                extractRowKey={(row) => row.ApplicationUserLogId}
                paginationProps={{
                    skip: skip,
                    take: rowsPerPage,
                    takeOptions: ROW_SELECTION_OPTIONS,
                    onChangeTakeCb: (newTake) => {
                        dispatch(setRowsPerPage(newTake));
                        dispatch(setSkip(0))
                    },
                    total: totalLogs,
                    onChange: (take, t) => {
                        dispatch(setRowsPerPage(take));
                        dispatch(setSkip(t))
                    },
                }}
            />
        </Loadable>
        <Popup title={"View details"} onCloseCb={()=>{setShowDetailsPopup(false)}} isPopupOpen={showDetailsPopup} customPopupSyles={styles.ActivityDetailsPopupCustom} childrenStyles={styles.ActivityDetailsPopupChildren}>
            <div style={styles.detailsTable}>
                <div style={styles.detailsRow}>
                    <div style={{...styles.detailsColumn, borderRight: '1px solid #262626'}}><Label weight={LABEL_WEIGHT[700]} customStyles={styles.detailsText}>Name</Label></div>
                    <div style={styles.detailsColumn}><Label weight={LABEL_WEIGHT[700]} customStyles={styles.detailsText}>Value</Label></div>
                </div>
                  {selectedLog?.map(detail => {
                      return detail?.TagValue ? <div style={styles.detailsRow}>
                          <div style={{ ...styles.detailsColumn, borderRight: '1px solid #262626' }}><Label weight={LABEL_WEIGHT[500]} customStyles={styles.detailsText}>{detail.TagName}</Label></div>
                          <div style={styles.detailsColumn}><Label weight={LABEL_WEIGHT[500]} customStyles={styles.detailsText}>{detail.TagValue}</Label></div>
                      </div> : null
                  }
                  )}
            </div>
        </Popup>
    </div>
  )
}